{
  "common": {
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "search": "Search",
    "viewMore": "View more",
    "viewAll": "View all"
  },
  "header": {
    "nav": {
      "brands": "Brands",
      "reviews": "Reviews",
      "causes": "Causes",
      "howItWorks": "How it works",
      "about": "About us"
    },
    "search": {
      "placeholder": "Search partner stores..."
    },
    "user": {
      "myAccount": "My Account",
      "settings": "Settings",
      "myCause": "My Cause",
      "adminPanel": "Admin Panel",
      "logout": "Sign out",
      "fallbackName": "User"
    },
    "menu": {
      "myProfile": "My Profile",
      "navigate": "Browse"
    },
    "auth": {
      "login": "Sign in",
      "register": "Sign up"
    }
  },
  "footer": {
    "tagline": "Turning shopping into donations since January 2025.",
    "sections": {
      "forYou": "For you",
      "institutional": "Company",
      "contact": "Contact"
    },
    "links": {
      "howItWorks": "How it works",
      "partnerStores": "Partner Stores",
      "causes": "Causes",
      "register": "Sign up",
      "about": "About Us",
      "howWeGenerate": "How we generate revenue",
      "partner": "Become a Partner",
      "privacy": "Privacy",
      "terms": "Terms of Use",
      "cookies": "Cookie preferences",
      "contact": "Get in touch"
    },
    "promovendo": {
      "title": "Generate to Donate",
      "intro": "Cupom Verificado is an initiative by",
      "brand": "Promovendo o Bem",
      "body": ", a non-profit organization practicing true social entrepreneurship. Our commission covers operating costs and",
      "reinvested": "every surplus is reinvested in social projects",
      "cta": "Learn more"
    },
    "rights": "All rights reserved."
  },
  "hero": {
    "badgeBrands": "{{count}} partner brands",
    "badgeFallback": "Partner brands",
    "headlineStart": "",
    "headlineHighlight": "Charitable Cashback",
    "headlineEnd1": " is",
    "headlineEnd2": "at Cupom Verificado",
    "lead": "Giving and saving has never been easier.",
    "subheadline": "You pay the same at your favorite stores. The donation happens automatically.",
    "ctaStart": "Start donating",
    "ctaCause": "Nominate a cause",
    "metricsTitle": "Cupom Verificado in numbers",
    "sinceLine": "Bringing awareness to the way you shop since",
    "stats": {
      "gmv": "in sales generated for brands",
      "raised": "confirmed fundraising",
      "monitoredProducts": "monitored products",
      "comparableProducts": "products available to compare",
      "products50Plus": "products with 50% off or more",
      "activeCoupons": "active discount coupons",
      "users": "Users",
      "brands": "active stores",
      "causes": "active causes",
      "volunteers": "volunteers"
    }
  },
  "brand": {
    "viewCoupon": "View coupon",
    "goShopping": "Go shopping",
    "activateDonation": "Activate donation"
  },
  "cookie": {
    "message": "We use cookies to improve your experience.",
    "accept": "Accept",
    "decline": "Decline",
    "title": "Your privacy",
    "body": "We use essential cookies and advertising cookies (Google AdSense) to support the platform and show relevant ads. You can accept or decline marketing cookies at any time.",
    "learnMore": "Learn more",
    "ariaLabel": "Cookie notice",
    "close": "Close"
  },
  "howItWorks": {
    "title": "How it works",
    "subtitle": "You pay the same price. The donation happens on its own.",
    "closingLead": "The rest of the commission keeps the platform running. ",
    "closingHighlight": "What is left over is donated too",
    "closingTail": ". A 100% social project, built to generate impact.",
    "causeCta": "Register a cause",
    "steps": {
      "register": {
        "title": "Create your account",
        "description": "Less than a minute to pick the cause you want to support."
      },
      "pickStore": {
        "title": "Pick a store",
        "description": "390 partner stores and over a million products — shop where you already shop."
      },
      "buy": {
        "title": "Shop as usual",
        "description": "Click 'Go shopping' and check out at the store. No extra fees."
      },
      "donate": {
        "title": "The donation happens on its own",
        "description": "The store pays us a commission and part of it becomes a donation to your cause."
      }
    }
  },
  "brandsCarousel": {
    "title": "Brands that make a difference",
    "subtitleWithCount": "Choose from our {{count}} partner stores. Every purchase generates automatic donations for the cause you support.",
    "subtitle": "Every purchase generates automatic donations for the cause you support.",
    "empty": "No brands found in this category.",
    "viewAll": "View all stores",
    "error": "Couldn't load brands.",
    "retry": "Try again",
    "loading": "Loading brands...",
    "donatesUpTo": "Donates up to {{value}}"
  },
  "causesShowcase": {
    "title": "Causes that transform lives",
    "subtitle": "Pick an organization to support. Your donation is automatic with every purchase you make.",
    "viewAll": "View all causes",
    "loading": "Loading causes...",
    "error": "Couldn't load causes.",
    "retry": "Try again",
    "empty": "No causes found at the moment.",
    "viewCause": "View Cause",
    "defaultDescription": "Support this cause and transform lives.",
    "coverAlt": "{{name}} cover"
  }
}
